import React, { useContext, useEffect, useState } from 'react';
import Sidebar from '../../../layouts/global/dashboard/Sidebar';
import TopHeader from '../../../layouts/global/dashboard/TopHeader';
import airtimeImg from '../../../assets/images/airtime.svg';
import giftImg from '../../../assets/images/gift.svg';
import { Redirect } from 'react-router';
import { AuthContext } from '../../../contexts/AuthContext';
import axios from 'axios';
import { BeneficiaryContext } from '../../../contexts/BeneficiaryContext';
import AllGroups from '../../../layouts/dashboard/AllGroups';
import LoadingSpinner from '../../../components/LoadingSpinner';
import RewardConfirmation from '../../../layouts/dashboard/RewardConfirmation';
import PageTitle from '../../../layouts/global/dashboard/PageTitle';

export default function Rewards() {
  const { state } = useContext(AuthContext);
  const { groups, token, loading } = useContext(BeneficiaryContext);
  const [rewardInit, setRewardInit] = useState({ step: 0, type: null });
  const [amount, setAmount] = useState('');
  const [group, setGroup] = useState({
    name: null,
    id: null,
  });

  const [modalIsOpen, setIsOpen] = useState(false);
  const openModal = () => setIsOpen(true);

  const closeModal = () => setIsOpen(false);

  const [wallet, setWallet] = useState(null);

  const loadWallet = async () => {
    const response = await axios.get(
      'https://secret-ridge-31139.herokuapp.com/api/auth/user-profile',
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return setWallet(response.data.wallet);
  };

  const sendAirtime = async (amount, groupId) => {
    const response = await axios.post(
      'https://secret-ridge-31139.herokuapp.com/api/send_bulk_airtime',
      {
        amount,
        group_id: groupId,
        currency_code: wallet && wallet.currency_code,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    console.log(response);
  };

  useEffect(() => {
    loadWallet();
  }, []);

  return (
    <div>
      {state.isAuth ? (
        <Redirect to="/dashboard/rewards" />
      ) : (
        <Redirect to="/login" />
      )}
      {amount && (
        <RewardConfirmation
          modalIsOpen={modalIsOpen}
          closeModal={closeModal}
          amount={amount}
          handler={sendAirtime}
          group={group}
          currency={wallet.currency_code}
        />
      )}
      <main className={'flex flex-col lg:flex-row'}>
        <Sidebar />
        <TopHeader />
        <section className={'lg:w-full bg-gray-100 min-h-screen'}>
          <div
            className={'w-full px-5 py-5 lg:pl-72 pt-20 lg:pr-10 bg-gray-100'}
          >
            <PageTitle title={'Rewards'} />
            <div
              style={{ minHeight: 500 }}
              className={'p-5 shadow bg-white w-full'}
            >
              <div className={'mb-3 px-2'}>
                <h3 className={'text-lg text-yellow-500'}>
                  Choose reward type
                </h3>
              </div>
              <div
                className={
                  'flex flex-row justify-between lg:justify-around items-start'
                }
              >
                <div className={'w-full p-2'}>
                  <button
                    onClick={() => setRewardInit({ type: 'airtime', step: 1 })}
                    className={`w-full shadow rounded px-3 py-2 text-sm lg:text-xl ${
                      rewardInit.type === 'airtime'
                        ? `ring-2 ring-yellow-500`
                        : null
                    } bg-gray-100 text-gray-600`}
                  >
                    <div
                      className={
                        'flex flex-row justify-center items-center p-2 lg:p-5'
                      }
                    >
                      <img height={50} width={50} alt={''} src={airtimeImg} />
                      <div className={'ml-3'}>
                        <h3>Airtime</h3>
                      </div>
                    </div>
                  </button>
                </div>

                <div className={'w-full p-2'}>
                  <button
                    className={`w-full  shadow rounded px-3 py-2 text-sm lg:text-xl ${
                      rewardInit.type === 'gift'
                        ? `ring-2 ring-yellow-500`
                        : null
                    } bg-gray-100 text-gray-600`}
                  >
                    <div
                      className={
                        'flex flex-row justify-center items-center p-2 lg:p-5'
                      }
                    >
                      <img height={50} width={50} alt={''} src={giftImg} />
                      <div className={'ml-3'}>
                        <h3>Gift Cards</h3>
                      </div>
                    </div>
                  </button>
                </div>
              </div>
              <div className={'p-2'}>
                {rewardInit.type === 'airtime' ? (
                  <div className={'mt-2'}>
                    <div>
                      <h3 className={'text-lg text-yellow-500'}>
                        Enter the amount of airtime
                      </h3>
                    </div>
                    <input
                      placeholder={'Amount'}
                      className={
                        'p-2 border-2 bg-gray-50 rounded-sm my-2 w-full lg:w-1/3'
                      }
                      type={'number'}
                      min="1"
                      value={amount}
                      onChange={(e) => setAmount(e.target.value)}
                    />
                  </div>
                ) : null}
              </div>
              <div>
                <div className={'mb-3 px-2'}>
                  <h3 className={'text-lg text-yellow-500'}>
                    Choose group to send
                  </h3>
                </div>
                <AllGroups>
                  {loading ? (
                    <LoadingSpinner color={'text-yellow-400'} />
                  ) : groups.length > 0 ? (
                    groups.map((item, index) => (
                      <div key={index} className={'w-full lg:w-1/3 p-2'}>
                        <div className={'bg-gray-100 p-5'}>
                          <div
                            className={
                              'flex flex-row justify-between items-start'
                            }
                          >
                            <div>
                              <h3 className={'font-medium text-lg mr-2'}>
                                {item.group_name}
                              </h3>
                              <p>{item.description}</p>
                            </div>
                            <button
                              onClick={() => {
                                setGroup({
                                  name: item.group_name,
                                  id: item.id,
                                });
                                openModal();
                              }}
                              className={'cursor-pointer px-4 py-2 rounded m-3'}
                              style={{
                                backgroundColor: '#FCA310',
                              }}
                            >
                              Send
                            </button>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : null}
                </AllGroups>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
